import { useShowMoreLess } from '../../_hooks/use-show-more-less.js'
import { Gutter } from '../Gutter/index.js'
import { PaginationControls } from '../PaginationControls/index.jsx'
import { SmartLink } from '../SmartLink/SmartLink.jsx'

export const RelatedArticles = ({
  docs,
  initialItemsToShow = 4,
}: {
  initialItemsToShow?: number
  docs: Array<{
    articleUrl: string
    mediaUrl?: string
    mediaAlt: string
    title: string | null | undefined
    description?: string | null
    id: number
    readTimeEstimate?: string | null
  } | null>
}) => {
  const { currentItems, showMoreItems, showLessItems, hasMoreItems, hasLessItems } = useShowMoreLess(
    docs ?? [],
    initialItemsToShow,
  )

  return (
    <Gutter>
      <ul
        className={`m-0 gap-200 p-0 md:gap-500 ${currentItems.length < 3 ? 'grid grid-cols-1 sm:grid-cols-2 desktop:flex desktop:justify-center' : 'grid grid-cols-1 sm:grid-cols-2 desktop:grid-cols-3'}`}
      >
        {currentItems.map((result) => {
          if (!result || !result.title) {
            return null
          }

          const { mediaUrl, mediaAlt, articleUrl, title, id, description, readTimeEstimate } = result

          return (
            <li key={id} className="w-full desktop:max-w-[453px]">
              <SmartLink to={articleUrl} title={title}>
                <div className="rounded-20 flex flex-1 flex-col gap-300">
                  {mediaUrl && (
                    <>
                      <div
                        className="relative overflow-hidden rounded-200 bg-cover bg-center pb-[56%]"
                        style={{ backgroundImage: `url("${mediaUrl}")` }}
                        role="img"
                        aria-label={mediaAlt}
                      />
                    </>
                  )}
                  <div className="flex flex-col gap-75 self-stretch">
                    <h3 className="headline md:title3-emphasized text-primaryDim">{title}</h3>{' '}
                    {description && <p className="body1 md:body2 mt-100 text-onPrimaryContainer">{description}</p>}
                    {readTimeEstimate && <p className="caption1 text-onSurfaceVariant">{readTimeEstimate}</p>}
                  </div>
                </div>
              </SmartLink>
            </li>
          )
        })}
      </ul>
      <div className="flex justify-center">
        <PaginationControls
          hasMoreItems={hasMoreItems}
          showMoreItems={showMoreItems}
          hasLessItems={hasLessItems}
          showLessItems={showLessItems}
        />
      </div>
    </Gutter>
  )
}
